import { useMessageInstanceEvent } from '@atlassian/message-instance-event-frontend-client/useMessageInstanceEvent';

import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';

import { useMessageEvent } from '@post-office/message-lifecycle';

export const useHandleDismiss = ({
	onDismissed,
	closeInteractionIdentifier,
	legacyCtaDismissIdentifier,
}: {
	onDismissed: () => void;
	closeInteractionIdentifier: string;
	legacyCtaDismissIdentifier: string;
}): {
	handleDismiss: () => void;
	handleCtaDismiss: () => void;
} => {
	const { messageInstanceClicked } = useMessageInstanceEvent();
	const { messageDismissed } = useMessageEvent();
	const { onClosed } = usePostOfficeUserInteractions();

	const handleDismiss = (): void => {
		void onClosed({ interactionIdentifier: closeInteractionIdentifier, additionalMetadata: {} });
		void messageDismissed();
		onDismissed();
	};

	const handleCtaDismiss = (): void => {
		void messageInstanceClicked({
			messageEventType: 'clicked',
			clickedElement: {
				clickIdentifier: legacyCtaDismissIdentifier,
				clickedElement: 'button',
				buttonType: 'secondary',
			},
			action: { actionType: 'dismiss' },
			additionalMetadataFromFrontend: {},
		});
		void messageDismissed();
		onDismissed();
	};

	return { handleDismiss, handleCtaDismiss };
};
